/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  PublishPluginsRequestBody,
  PublishPluginsRequestBody$Outbound,
  PublishPluginsRequestBody$outboundSchema,
} from "../components/publishpluginsrequestbody.js";

export type PublishPluginsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type PublishPluginsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  publishPluginsRequestBody: PublishPluginsRequestBody;
};

/** @internal */
export type PublishPluginsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PublishPluginsSecurity$outboundSchema: z.ZodMiniType<
  PublishPluginsSecurity$Outbound,
  PublishPluginsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function publishPluginsSecurityToJSON(
  publishPluginsSecurity: PublishPluginsSecurity,
): string {
  return JSON.stringify(
    PublishPluginsSecurity$outboundSchema.parse(publishPluginsSecurity),
  );
}

/** @internal */
export type PublishPluginsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  PublishPluginsRequestBody: PublishPluginsRequestBody$Outbound;
};

/** @internal */
export const PublishPluginsRequest$outboundSchema: z.ZodMiniType<
  PublishPluginsRequest$Outbound,
  PublishPluginsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    publishPluginsRequestBody: PublishPluginsRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      publishPluginsRequestBody: "PublishPluginsRequestBody",
    });
  }),
);

export function publishPluginsRequestToJSON(
  publishPluginsRequest: PublishPluginsRequest,
): string {
  return JSON.stringify(
    PublishPluginsRequest$outboundSchema.parse(publishPluginsRequest),
  );
}
